import { render, staticRenderFns } from "./InputNumber.vue?vue&type=template&id=72a70cd0&"
import script from "./InputNumber.vue?vue&type=script&lang=js&"
export * from "./InputNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports